import TextField from "@mui/material/TextField";
import React from "react";
import { InputLabel } from '@mui/material';
import Grid from "@mui/material/Grid/Grid";

export default (data, key) => {
    return (<Grid item md={6} xs={12} key={key} className={data.classList}>
            <TextField
                type={'number'}
                required={data?.inputProps?.required ?  true : false}
                error={data.error ? true : false}
                helperText={data.error}
                inputProps={data.inputProps || {}}
                fullWidth
                id={`${data.name}-${key}`}
                label={data.headerName}
                value={data.value}
                name={data.name}
                onChange={data.onCallback}
            />
        </Grid>)
}